import styled from "@emotion/styled";
import { FC, ReactNode } from "react";

import { DesignToken, RadiusToken, ShadowToken, SpacingToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

interface IProps {
  children: ReactNode;
}

export const CodeSnippet: FC<IProps> = ({ children }) => (
  <Flex justifyContent="center" role="presentation" aria-hidden="true" data-testid="code-snippet">
    <Flex
      maxWidth="560px"
      maxHeight="196px"
      borderRadius={withVar(RadiusToken.Radius3)}
      padding={withVar(SpacingToken.Spacing4)}
      relative
      marginBottom="6px"
      css={{
        boxShadow: withVar(ShadowToken.Float),
      }}
    >
      <Code>{children}</Code>
    </Flex>
  </Flex>
);

const Code = styled(Text)`
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  overflow-y: auto;
  color: ${withVar(DesignToken.ContentBasicSecondary)};
  &::after {
    content: "";
    position: absolute;
    height: 8rem;
    width: 100%;
    bottom: 0;
    left: 0;
    background: linear-gradient(180deg, transparent 0%, ${withVar(DesignToken.SurfacePrimaryDefault)} 100%);
    pointer-events: none;
    border-radius: ${withVar(RadiusToken.Radius3)};
  }
`;
